import { createContext, ReactElement, ReactNode, useContext } from 'react'

import { useSuppliersBalanceFilters, UseSuppliersBalanceFiltersResult } from '../hooks/useSuppliersBalanceFilters'

const SuppliersBalanceFiltersContext = createContext<UseSuppliersBalanceFiltersResult | undefined>(undefined)

interface SuppliersBalanceFiltersProviderProps {
  children?: ReactNode
}

export const SuppliersBalanceFiltersProvider = ({ children }: SuppliersBalanceFiltersProviderProps): ReactElement => {
  const value = useSuppliersBalanceFilters()

  return <SuppliersBalanceFiltersContext.Provider value={value}>{children}</SuppliersBalanceFiltersContext.Provider>
}

export const useSuppliersBalanceFiltersContext = (): UseSuppliersBalanceFiltersResult => {
  const context = useContext(SuppliersBalanceFiltersContext)

  if (!context) {
    throw new Error('SuppliersBalanceFiltersProvider is missing in the tree.')
  }

  return context
}
